import { render } from "./ViewFormItem.vue?vue&type=template&id=9e13fd7a&scoped=true"
import script from "./ViewFormItem.vue?vue&type=script&lang=js"
export * from "./ViewFormItem.vue?vue&type=script&lang=js"

import "./ViewFormItem.vue?vue&type=style&index=0&id=9e13fd7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e13fd7a"]])

export default __exports__